import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

// Import components
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Service from './pages/Service';
import Feature from './pages/Feature';
import Countries from './pages/Countries';
import Testimonial from './pages/Testimonial';
import Training from './pages/Training';
import Contact from './pages/Contact';
import ImmigrationServices from './pages/ImmigrationServices';
import BusinessSetup from './pages/BusinessSetup';
import BusinessSupport from './pages/BusinessSupport';
import NotFound from './pages/NotFound';

function App() {
  useEffect(() => {
    // Wait for all scripts to load
    const initializeLibraries = () => {
      if (typeof window !== 'undefined') {
        // Initialize Bootstrap components
        if (window.bootstrap) {
          // Initialize tooltips
          const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
          tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new window.bootstrap.Tooltip(tooltipTriggerEl);
          });

          // Initialize popovers
          const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
          popoverTriggerList.map(function (popoverTriggerEl) {
            return new window.bootstrap.Popover(popoverTriggerEl);
          });
        }

        // Initialize WOW.js for animations
        if (window.WOW) {
          new window.WOW().init();
        }

        // Initialize counter-up with better timing
        if (window.jQuery && window.jQuery.fn.counterUp) {
          // Wait a bit for WOW animations to complete
          setTimeout(() => {
            window.jQuery('[data-toggle="counter-up"]').each(function() {
              const $this = window.jQuery(this);
              const countTo = $this.text();
              
              $this.text('0');
              
              window.jQuery({ countNum: 0 }).animate({
                countNum: countTo
              }, {
                duration: 2000,
                easing: 'swing',
                step: function() {
                  $this.text(Math.floor(this.countNum));
                },
                complete: function() {
                  $this.text(countTo);
                }
              });
            });
          }, 1000);
        }

        // Initialize sticky navbar
        if (window.jQuery) {
          window.jQuery(window).scroll(function () {
            if (window.jQuery(this).scrollTop() > 45) {
              window.jQuery('.nav-bar').addClass('sticky-top shadow-sm');
            } else {
              window.jQuery('.nav-bar').removeClass('sticky-top shadow-sm');
            }
          });
        }

        // Initialize back to top button
        if (window.jQuery) {
          window.jQuery(window).scroll(function () {
            if (window.jQuery(this).scrollTop() > 300) {
              window.jQuery('.back-to-top').fadeIn('slow');
            } else {
              window.jQuery('.back-to-top').fadeOut('slow');
            }
          });
          
          window.jQuery('.back-to-top').click(function () {
            window.jQuery('html, body').animate({scrollTop: 0}, 1500, 'easeInOutExpo');
            return false;
          });
        }

        // Initialize testimonial carousel
        if (window.jQuery && window.jQuery.fn.owlCarousel) {
          window.jQuery(".testimonial-carousel").owlCarousel({
            autoplay: true,
            smartSpeed: 2000,
            center: false,
            dots: false,
            loop: true,
            margin: 25,
            nav : true,
            navText : [
              '<i class="bi bi-arrow-left"></i>',
              '<i class="bi bi-arrow-right"></i>'
            ],
            responsiveClass: true,
            responsive: {
              0:{
                items:1
              },
              576:{
                items:1
              },
              768:{
                items:2
              },
              992:{
                items:2
              },
              1200:{
                items:2
              }
            }
          });
        }

        // Initialize hero carousel
        if (window.jQuery && window.jQuery.fn.carousel) {
          window.jQuery('.carousel').carousel({
            interval: 5000,
            pause: 'hover'
          });
        }
      }
    };

    // Check if libraries are already loaded
    if (window.jQuery && window.WOW) {
      initializeLibraries();
    } else {
      // Wait for libraries to load
      const checkLibraries = setInterval(() => {
        if (window.jQuery && window.WOW) {
          clearInterval(checkLibraries);
          initializeLibraries();
        }
      }, 100);

      // Timeout after 10 seconds
      setTimeout(() => {
        clearInterval(checkLibraries);
        console.warn('Some libraries failed to load');
      }, 10000);
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/service" element={<Service />} />
            <Route path="/feature" element={<Feature />} />
            <Route path="/countries" element={<Countries />} />
            <Route path="/testimonial" element={<Testimonial />} />
            <Route path="/training" element={<Training />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/immigration" element={<ImmigrationServices />} />
            <Route path="/business-setup" element={<BusinessSetup />} />
            <Route path="/business-support" element={<BusinessSupport />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App; 